/* This file is autogenerated, see readme.md for instructions */
import TragetSvgIcon from '@bloomreach/banana-theme/icons/traget.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TragetIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TragetSvgIcon />
    </Icon>
  );
});

TragetIcon.displayName = 'TragetIcon';

export default TragetIcon;
